/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-building-insights-3': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.5 1.25H10c-.69 0-1.25.56-1.25 1.25v6.25H2.5c-.69 0-1.25.56-1.25 1.25v8.75h17.5V2.5c0-.69-.56-1.25-1.25-1.25zM5.625 17.5v-4.375h2.5V17.5h-2.5zm11.875 0H9.375v-5a.625.625 0 00-.625-.625H5a.625.625 0 00-.625.625v5H2.5V10H10V2.5h7.5v15zM11.25 5h1.25v1.25h-1.25V5zM15 5h1.25v1.25H15V5zm-3.75 3.75h1.25V10h-1.25V8.75zm3.75 0h1.25V10H15V8.75zm-3.75 3.75h1.25v1.25h-1.25V12.5zm3.75 0h1.25v1.25H15V12.5zM1.25 6.25h3.125V7.5H1.25V6.25zm5-5H7.5v3.125H6.25V1.25zM2.5 3.384l.884-.884 2.241 2.24-.884.885L2.5 3.384z"/>'
  }
})
